import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import BusTabs from "../AllTabs/BusTabs";
import BusOffers from "../Advertisements/BusOffers";
import SearchBusPanel from "./SearchBusPanel"; // Import the new component

const SearchBus = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Handle search from the SearchBusPanel component
  const handleSearch = (searchQuery) => {
    navigate("/bus/results", { state: { searchQuery } });
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <BusTabs pageName="SEARCH" />
              </div>
              {/* Use the SearchBusPanel component */}
              <SearchBusPanel onSearch={handleSearch} />
            </div>
            {/* Add BusOffers advertisements here */}
            <BusOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBus;
